import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  undoSubStepCompletion,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * サブステップの完了を取消す mutation hook。
 * onSuccess で detail + list query を invalidate する。
 */
export function useUndoSubStepCompletion(
  caseId: string,
): InvalidatingMutationResultFor<typeof undoSubStepCompletion> {
  return useInvalidatingMutation(undoSubStepCompletion, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
